import instance from '../../../api/axios'
import { FolderItem } from '../types/files'

export const loadAllFolders = async (): Promise<FolderItem[]> => {
  const response = await instance.get('/files/folders/all')
  return response.data || []
}

export default loadAllFolders
